__turbopack_context__.v({
  "splide-loading": "L_Eofa_splide-loading",
  "splide_slidewrap": "L_Eofa_splide_slidewrap",
});
